import { Menu, X } from 'lucide-react'
import { useState } from 'react'
import { getLocaleUrls } from '../lib/localeUrls.js'

export default function Header({ locale, copy, menuOpen, onMenuToggle, onMenuClose }) {
  const [activeSection, setActiveSection] = useState('calculator')
  const localeUrls = getLocaleUrls()

  function selectSection(section) {
    setActiveSection(section)
    onMenuClose()
  }

  return (
    <header className="site-header">
      <a className="wordmark" href="#top" aria-label={copy.homeLabel} onClick={() => selectSection('calculator')}>Measures of Mankind</a>

      <nav id="primary-navigation" className={`main-nav${menuOpen ? ' is-open' : ''}`} aria-label={copy.primaryNavigation}>
        <a className={activeSection === 'calculator' ? 'active' : ''} href="#calculator" onClick={() => selectSection('calculator')}>{copy.navCalculator}</a>
        <a className={activeSection === 'systems' ? 'active' : ''} href="#systems" onClick={() => selectSection('systems')}>{copy.navSystems}</a>
        <a href="https://www.guidebg.com/in-the-measures-of-mankind/" target="_blank" rel="noreferrer">{copy.navArticle}</a>
      </nav>

      <div className="language-switch" aria-label={copy.languageNavigation}>
        <a className={locale === 'en' ? 'active' : ''} aria-current={locale === 'en' ? 'page' : undefined} href={localeUrls.en} hrefLang="en">EN</a>
        <span aria-hidden="true">/</span>
        <a className={locale === 'bg' ? 'active' : ''} aria-current={locale === 'bg' ? 'page' : undefined} href={localeUrls.bg} hrefLang="bg">BG</a>
        <span aria-hidden="true">/</span>
        <a className={locale === 'de' ? 'active' : ''} aria-current={locale === 'de' ? 'page' : undefined} href={localeUrls.de} hrefLang="de">DE</a>
      </div>

      <button className="menu-button" type="button" onClick={onMenuToggle} aria-expanded={menuOpen} aria-controls="primary-navigation" aria-label={menuOpen ? copy.closeMenu : copy.openMenu}>
        {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
      </button>
    </header>
  )
}
